import { Component, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { TranslateService } from "@ngx-translate/core";
import * as _ from "lodash";

import { FuseConfigService } from "@fuse/services/config.service";
import { FuseSidebarService } from "@fuse/components/sidebar/sidebar.service";

import {
  navigation,
  navigation2,
  navigationteammember,
} from "app/navigation/navigation";

@Component({
  selector: "toolbar",
  templateUrl: "./toolbar.component.html",
  styleUrls: ["./toolbar.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class ToolbarComponent implements OnInit, OnDestroy {
  horizontalNavbar: boolean;
  rightNavbar: boolean;
  hiddenNavbar: boolean;
  languages: any;
  navigation: any;
  selectedLanguage: any;
  userStatusOptions: any[];
  logincompanyName: any;
  logoImage: any;

  userTypee: any;
  isTeamMember: string;
  // Private
  private _unsubscribeAll: Subject<any>;

  /**
   * Constructor
   *
   * @param {FuseConfigService} _fuseConfigService
   * @param {FuseSidebarService} _fuseSidebarService
   * @param {TranslateService} _translateService
   */
  constructor(
    private _fuseConfigService: FuseConfigService,
    private _fuseSidebarService: FuseSidebarService,
    private _translateService: TranslateService
  ) {
    // Set the defaults
    this.userStatusOptions = [
      {
        title: "Online",
        icon: "icon-checkbox-marked-circle",
        color: "#4CAF50",
      },
      {
        title: "Away",
        icon: "icon-clock",
        color: "#FFC107",
      },
      {
        title: "Do not Disturb",
        icon: "icon-minus-circle",
        color: "#F44336",
      },
      {
        title: "Invisible",
        icon: "icon-checkbox-blank-circle-outline",
        color: "#BDBDBD",
      },
      {
        title: "Offline",
        icon: "icon-checkbox-blank-circle-outline",
        color: "#616161",
      },
    ];

    this.languages = [
      {
        id: "en",
        title: "English",
        flag: "us",
      },
      {
        id: "tr",
        title: "Turkish",
        flag: "tr",
      },
    ];

    // this.navigation = navigation;

    // this.userTypee = localStorage.getItem('userTypeId');
    // this.isTeamMember = localStorage.getItem('isTeammemberLogin');

    this.userTypee = localStorage.getItem("userTypeId");
    this.isTeamMember = localStorage.getItem("isTeammemberLogin");
    // var cSession =   JSON.parse(localStorage.getItem('c_session'));
    // this.userTypee = cSession['userType'].userTypeId;
    // this.isTeamMember = localStorage.getItem('c_isTeammemberLogin');
    // let isProfile = cSession['subActive'];

    // Get default navigation
    if (this.userTypee == "3") {
      this.navigation = navigation2;
    } else if (this.userTypee == "1" || this.userTypee == "2") {
      if (this.isTeamMember == "true") {
        this.navigation = navigationteammember;
      } else {
        this.navigation = navigation;
      }
    } else {
      this.navigation = navigation;
    }

    /* Start ---------------  */

    /* End ---------------  */

    // Set the private defaults
    this._unsubscribeAll = new Subject();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // var cSession1 =   JSON.parse(localStorage.getItem('c_session'));
    // // alert('iam firs  '+ cSession1['companyName']);
    // this.logincompanyName = cSession1.companyName;
    // this.logoImage = cSession1.logo;
    // ==========================================================================

    this.logincompanyName = JSON.parse(
      localStorage.getItem("logincompanyName")
    );
    console.log("this.loginCompanyName", this.logincompanyName);
    this.logoImage = JSON.parse(localStorage.getItem("logoImage"));
    // alert(this.logincompanyName)
    // =========================================================================
    // alert(cSession1)
    // this.logincompanyName = JSON.parse(localStorage.getItem('logincompanyName'));
    // console.log('this.loginCompanyName', this.logincompanyName);
    // this.logoImage = JSON.parse(localStorage.getItem('logoImage'));
    // alert(this.logincompanyName)

    //console.log('this.naviation on ngoninit!!!!!!!!!!!!!!!!!!!11', this.navigation);
    // Subscribe to the config changes
    this._fuseConfigService.config
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((settings) => {
        this.horizontalNavbar = settings.layout.navbar.position === "top";
        this.rightNavbar = settings.layout.navbar.position === "right";
        this.hiddenNavbar = settings.layout.navbar.hidden === true;
      });

    // Set the selected language from default languages
    this.selectedLanguage = _.find(this.languages, {
      id: this._translateService.currentLang,
    });
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Toggle sidebar open
   *
   * @param key
   */
  toggleSidebarOpen(key): void {
    this._fuseSidebarService.getSidebar(key).toggleOpen();
  }

  /**
   * Search
   *
   * @param value
   */
  search(value): void {
    // Do your search here...
    //console.log(value);
  }

  /**
   * Set the language
   *
   * @param lang
   */
  setLanguage(lang): void {
    // Set the selected language for the toolbar
    this.selectedLanguage = lang;

    // Use the selected language for translations
    this._translateService.use(lang.id);
  }

  // tslint:disable-next-line: typedef
  onLoggedOut() {
    localStorage.setItem("isLoggedin", "false");
    localStorage.setItem("c_isLoggedin", "false");
    sessionStorage.clear();
    localStorage.clear();
    //    alert('this is an clear alert')
  }
}
